/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Payment } from '../models';
/**
 * DunningApi - axios parameter creator
 * @export
 */
export const DunningApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get text for dunning
         * @param {number} damageCaseId 
         * @param {string} type 
         * @param {string} deadline 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageCasePaymentDunningtextDamageCaseIdTypeDeadlineGet: async (damageCaseId: number, type: string, deadline: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'damageCaseId' is not null or undefined
            assertParamExists('damageCasePaymentDunningtextDamageCaseIdTypeDeadlineGet', 'damageCaseId', damageCaseId)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('damageCasePaymentDunningtextDamageCaseIdTypeDeadlineGet', 'type', type)
            // verify required parameter 'deadline' is not null or undefined
            assertParamExists('damageCasePaymentDunningtextDamageCaseIdTypeDeadlineGet', 'deadline', deadline)
            const localVarPath = `/damageCasePayment/dunningtext/{damageCaseId}/{type}/{deadline}`
                .replace(`{${"damageCaseId"}}`, encodeURIComponent(String(damageCaseId)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"deadline"}}`, encodeURIComponent(String(deadline)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sent E-Mail to context-Lawyer
         * @param {number} damageCaseId 
         * @param {Payment} payment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageCasePaymentEmailDamageCaseIdPost: async (damageCaseId: number, payment: Payment, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'damageCaseId' is not null or undefined
            assertParamExists('damageCasePaymentEmailDamageCaseIdPost', 'damageCaseId', damageCaseId)
            // verify required parameter 'payment' is not null or undefined
            assertParamExists('damageCasePaymentEmailDamageCaseIdPost', 'payment', payment)
            const localVarPath = `/damageCasePayment/email/{damageCaseId}`
                .replace(`{${"damageCaseId"}}`, encodeURIComponent(String(damageCaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(payment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DunningApi - functional programming interface
 * @export
 */
export const DunningApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DunningApiAxiosParamCreator(configuration)
    return {
        /**
         * Get text for dunning
         * @param {number} damageCaseId 
         * @param {string} type 
         * @param {string} deadline 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damageCasePaymentDunningtextDamageCaseIdTypeDeadlineGet(damageCaseId: number, type: string, deadline: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Payment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damageCasePaymentDunningtextDamageCaseIdTypeDeadlineGet(damageCaseId, type, deadline, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sent E-Mail to context-Lawyer
         * @param {number} damageCaseId 
         * @param {Payment} payment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damageCasePaymentEmailDamageCaseIdPost(damageCaseId: number, payment: Payment, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Payment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damageCasePaymentEmailDamageCaseIdPost(damageCaseId, payment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DunningApi - factory interface
 * @export
 */
export const DunningApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DunningApiFp(configuration)
    return {
        /**
         * Get text for dunning
         * @param {number} damageCaseId 
         * @param {string} type 
         * @param {string} deadline 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageCasePaymentDunningtextDamageCaseIdTypeDeadlineGet(damageCaseId: number, type: string, deadline: string, options?: any): AxiosPromise<Payment> {
            return localVarFp.damageCasePaymentDunningtextDamageCaseIdTypeDeadlineGet(damageCaseId, type, deadline, options).then((request) => request(axios, basePath));
        },
        /**
         * Sent E-Mail to context-Lawyer
         * @param {number} damageCaseId 
         * @param {Payment} payment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageCasePaymentEmailDamageCaseIdPost(damageCaseId: number, payment: Payment, options?: any): AxiosPromise<Payment> {
            return localVarFp.damageCasePaymentEmailDamageCaseIdPost(damageCaseId, payment, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DunningApi - object-oriented interface
 * @export
 * @class DunningApi
 * @extends {BaseAPI}
 */
export class DunningApi extends BaseAPI {
    /**
     * Get text for dunning
     * @param {number} damageCaseId 
     * @param {string} type 
     * @param {string} deadline 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DunningApi
     */
    public damageCasePaymentDunningtextDamageCaseIdTypeDeadlineGet(damageCaseId: number, type: string, deadline: string, options?: AxiosRequestConfig) {
        return DunningApiFp(this.configuration).damageCasePaymentDunningtextDamageCaseIdTypeDeadlineGet(damageCaseId, type, deadline, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sent E-Mail to context-Lawyer
     * @param {number} damageCaseId 
     * @param {Payment} payment 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DunningApi
     */
    public damageCasePaymentEmailDamageCaseIdPost(damageCaseId: number, payment: Payment, options?: AxiosRequestConfig) {
        return DunningApiFp(this.configuration).damageCasePaymentEmailDamageCaseIdPost(damageCaseId, payment, options).then((request) => request(this.axios, this.basePath));
    }
}
